<template>
  <project-one-rail-layout :base-properties="baseProperties" />
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import ProjectOneRailLayout from '@/projectOne/components/rightRail/ProjectOneRailLayout';

export default {
  components: {ProjectOneRailLayout},

  computed: {
    ...mapState('projectOne', ['isThemeSelected', 'isReselectingTheme', 'moduleGroups']),
  },

  created() {
    this.fetchModule({
      buildId: this.$route.params.buildId,
      module: 'paint-scheme',
      presetPK: this.$route.query?.presetPK,
      // Need conditional for forceGet (can't just be true) for instances when user has made selections, progressed in stepper, and then backtracks to paint & theme customizer view
      // In that case, need to return forceGet as false and show their selections via POST
      forceGet: this.isThemeSelected ? false : true,
      isReselectingTheme: this.isReselectingTheme,
    }).then(() => {
      const railConfig = {
        content: {
          isRootModuleGroups: true,
        },
      };

      this.clearRailDataStack();
      this.pushToRailDataStack(railConfig);

      this.$nextTick(() => {
        this.setIsReselectingTheme(false);
        this.calculateApplicationHeight();
      });
    });
  },

  methods: {
    ...mapActions('projectOne', ['fetchModule', 'proceedToNextStep']),
    ...mapMutations('projectOne', [
      'pushToRailDataStack',
      'clearRailDataStack',
      'calculateApplicationHeight',
      'setIsReselectingTheme',
    ]),
  },
};
</script>
